import { Box, Grid2, Stack, Typography } from "@mui/material";
import "../../styles/LoginPage.css";
import "../../styles/PolicyTermCondition.css";
import { deeplinkingPackageDetails, deeplinkingDetail } from "../../data/PrivacyPolicy";
import { ReactComponent as Arrows } from "../../assets/logos/dplink-arrow.svg";
import { ReactComponent as Tick } from "../../assets/logos/dplink-location-tick.svg";

const Deeplinking = () => {

    const handlePlayStore = () => {
        window.location.href = 'https://play.google.com/store/apps/details?id=com.a2bdeliver.app&hl=en_IN';
    }

    const handleAppStore = () => {
        // window.location.href = 'https://example.com/1234';
    }

    return (
        <Stack sx={{
            minHeight: "100vh",
            backgroundColor: "white",
        }}>
            <Grid2 sx={{ backgroundColor: "#F8F9FF", marginBottom: "30px" }}>
                <Box sx={{ backgroundColor: "#0C68F4", margin: "16px", borderRadius: "20px", paddingBottom: "35px" }}>
                    <Box sx={{ padding: "12px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <img
                            src={require("../../assets/logos/dplink-a2b-logo.svg").default}
                            alt="a2bLogoImage"
                            style={{paddingTop: "30px", width: "62px", height: "62px"}}
                        />
                    </Box>
                    <h1 className="header-text" style={{ fontSize: "38px" }}>Welcome to A2B Deliver!</h1>
                    <Typography className="header-text" sx={{ fontSize: "16px" }}>Effortless Delivery Management at your Fingertips!</Typography>
                    <Box sx={{display: "flex", justifyContent: "center", alignItems: "center", gap: "15px", 
                        paddingLeft: "10%", paddingRight: "10%"}}>
                        <img
                            src={require("../../assets/logos/appstore-download.svg").default}
                            alt="appstore"
                            className="img-size"
                            onClick={handlePlayStore}
                        />
                        <img
                            src={require("../../assets/logos/andriod-download.svg").default}
                            alt="andriod"
                            className="img-size"
                            onClick={handleAppStore}
                        />
                    </Box>
                    <Box sx={{ padding: "12px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <img
                            src={require("../../assets/logos/dplink-my-delivery.svg").default}
                            alt="a2bMyDeliveryPage"
                            style={{width: "100%", height: "100%"}}
                        />
                    </Box>
                </Box>
                <Box className="border-box">
                    <Box sx={{ padding: "12px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <img
                            src={require("../../assets/logos/dplink-pk-listing-logo.svg").default}
                            alt="a2bMyDeliveryPage"
                            style={{paddingTop: "20px", width: "50%", height: "50%"}}
                        />
                    </Box>
                    <Typography sx={{ fontSize: "28px", color: "#2D2D2D", fontWeight: "600", textAlign: "center" }}>Package Listing</Typography>
                    <Typography className="body-text package-listing-text">Track, Manage, Deliver - All Your Packages in One Place!</Typography>
                    <Box sx={{ padding: "12px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <img
                            src={require("../../assets/logos/dplink-pk-listing.svg").default}
                            alt="a2bMyDeliveryPage"
                            style={{width: "100%", height: "100%"}}
                        />
                    </Box>
                </Box>
                <Box className="border-box">
                    <Box sx={{ padding: "12px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <img
                            src={require("../../assets/logos/dplink-pk-detail-logo.svg").default}
                            alt="a2bMyDeliveryPage"
                            style={{paddingTop: "20px", width: "50%", height: "50%"}}
                        />
                    </Box>
                    <Typography sx={{ fontSize: "28px", color: "#2D2D2D", fontWeight: "600", textAlign: "center" }}>Package Detail</Typography>
                    <Typography className="body-text">Comprehensive package information:</Typography>
                    <Box className="list-view">
                    {
                        deeplinkingPackageDetails.map((value, idx) => (
                            <Box key={idx} sx={{ display: "flex", paddingBottom: "12px"}}>
                                <Arrows style={{paddingTop: "4px"}} /><Typography sx={{paddingLeft: "10px"}} key={idx}>{value}</Typography>
                            </Box>
                        ))
                    }
                    </Box>
                    <Box sx={{ padding: "12px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <img
                            src={require("../../assets/logos/dplink-pk-detail.svg").default}
                            alt="a2bMyDeliveryPage"
                            style={{width: "100%", height: "100%"}}
                        />
                    </Box>
                </Box>
                <Box className="border-box">
                    <Box sx={{ padding: "12px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <img
                            src={require("../../assets/logos/dplink-map-logo.svg").default}
                            alt="a2bMyDeliveryPage"
                            style={{paddingTop: "20px", width: "50%", height: "50%"}}
                        />
                    </Box>
                    <Typography className="body-text details-text">Enhance security with geofencing technology!</Typography>
                    <Box sx={{ padding: "12px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <img
                            src={require("../../assets/logos/dplink-map.svg").default}
                            alt="a2bMyDeliveryPage"
                            style={{width: "100%", height: "100%"}}
                        />
                    </Box>
                </Box>
                <Box sx={{ backgroundColor: "#0C68F4", margin: "16px", borderRadius: "20px" }}>
                    <h1 className="deliver-text">Why Choose A2B Deliver?</h1>
                    <Box className="listing-details">
                    {
                        deeplinkingDetail.map((value, idx) => (
                            <Box key={idx} sx={{ display: "flex", paddingBottom: "12px"}}>
                                <Tick /><Typography sx={{paddingLeft: "10px", color: "white", fontSize: "16px"}} key={idx}>{value}</Typography>
                            </Box>
                        ))
                    }
                    </Box>
                    <Box sx={{display: "flex", justifyContent: "center", alignItems: "center", gap: "15px", 
                        paddingLeft: "10%", paddingRight: "10%"}}>
                        <img
                            src={require("../../assets/logos/appstore-download.svg").default}
                            alt="appstore"
                            className="img-size"
                            onClick={handlePlayStore}
                        />
                        <img
                            src={require("../../assets/logos/andriod-download.svg").default}
                            alt="andriod"
                            className="img-size"
                            onClick={handleAppStore}
                        />
                    </Box>
                    <Box sx={{ padding: "12px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <img
                            src={require("../../assets/logos/dplink-person-logo.svg").default}
                            alt="a2bMyDeliveryPage"
                            style={{width: "100%", height: "100%"}}
                        />
                    </Box>
                </Box>
            </Grid2>
        </Stack>
    )
}

export default Deeplinking